import React, { useState } from 'react';
import { useStores } from '../../hooks/use-stores';
import { useTranslation } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';
import {
  Alert,
  Col,
  Row,
} from 'react-bootstrap';

const Firmware = () => {
  const { batchStore } = useStores();
  const { t } = useTranslation();
  const [value, setValue] = useState<number>(0);
  const [error, setError] = useState<string>('');

  const isValid = (value: number) => {
    return value >= 0 && value <= 3;
  };

  const sendCommand = (value: number) => {
    setError('');

    if (!isValid(value)) {
      setError('Value must be between 0 and 3');
      return;
    }

    batchStore.pac.runWS(`set-racks ${value}`);
  };

  return (
    <>
      <Row>
        <Col sm={12}>
          <label>{t('Number of Racks')}</label>
        </Col>
      </Row>
      <Row>
        <Col sm={2}>
          <input
            name="value"
            type="number"
            min={0}
            max={3}
            maxLength={1}
            value={value || ''}
            onChange={(e: any) => setValue(e.target.value)}
            className="form-control input-sm narrow-pad"
          />
        </Col>
        <Col sm={3}>
          <Button
            className={'btn-sm btn-primary'}
            onClick={() => sendCommand(value)}
            title={t('Send command')}
          >
            {t('Send')}
          </Button>
        </Col>
      </Row>
      <Row className="margin-top-10">
        <Col sm={6}>
          {!!error && (
            <Alert bsStyle="danger">{error}</Alert>
          )}
        </Col>
      </Row>
    </>
  );
};

export { Firmware };
